import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { staggerContainer, fadeSlideLeft } from '../utils/animations';
const learningItems = ['Cómo reconocer los síntomas de la depresión', 'Cómo buscar ayuda profesional correctamente', 'Cómo crear rutinas que estabilicen tu estado de ánimo', 'Cómo usar ejercicio y nutrición para mejorar tu salud mental', 'Técnicas de meditación y mindfulness', 'Cómo fortalecer relaciones positivas', 'Cómo establecer metas pequeñas y motivadoras', 'Cómo recuperar tu esencia y tu brillo interior'];
export function LearningSection() {
  return <section className="relative py-28 md:py-32 px-4 bg-[#F7F3E9] overflow-hidden" data-id="element-171">
      {/* Decorative Orb */}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 -translate-x-1/3 w-[600px] h-[600px] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#6EC1E4]/10 via-transparent to-transparent blur-3xl pointer-events-none" data-id="element-172"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-174">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-serif text-[#2F3A3D] mb-4" data-id="element-175">
            Qué aprenderás
          </h2>
          <p className="text-xl text-[#F4A261] font-serif italic" data-id="element-176">
            Dentro del ebook descubrirás:
          </p>
        </motion.div>

        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-177">
          {learningItems.map((item, index) => <motion.div key={index} variants={fadeSlideLeft} className="flex items-center p-5 bg-white rounded-2xl shadow-[0_4px_20px_rgba(47,58,61,0.03)] border border-[#E8E1D5] hover:shadow-md transition-shadow" data-id="element-178">
              <div className="flex-shrink-0" data-id="element-179">
                <div className="w-10 h-10 rounded-xl bg-[#7FB77E]/15 flex items-center justify-center" data-id="element-180">
                  <CheckIcon className="w-5 h-5 text-[#7FB77E]" data-id="element-181" />
                </div>
              </div>
              <p className="ml-4 text-lg text-[#5F6368] leading-snug font-medium" data-id="element-182">
                {item}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}